import { motion } from "framer-motion";
import { IMAGES, WHATSAPP_URL } from "../../lib/constants";

const pillars = [
    { n: "01", t: "FUERZA", d: "Peso libre y progresión real" },
    { n: "02", t: "GLÚTEO", d: "Programa específico y científico" },
    { n: "03", t: "FUNCIONAL", d: "Movilidad, core y potencia" },
    { n: "04", t: "CARDIO", d: "HIIT controlado para definir" },
];

export default function Mujeres() {
    return (
        <section
            id="mujeres"
            data-testid="mujeres-section"
            className="relative bg-[#050505] py-24 md:py-32 overflow-hidden"
        >
            {/* Big background type */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
                <span className="font-display text-[28vw] leading-none text-white/[0.025] tracking-tighter select-none">
                    MUJERES
                </span>
            </div>

            <div className="relative max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 items-stretch">
                {/* Big image left */}
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.9 }}
                    className="lg:col-span-5 relative h-[520px] md:h-[680px] overflow-hidden border border-white/5"
                >
                    <img
                        src={IMAGES.womanLift2}
                        alt="Mujer fuerte entrenando"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
                    <div className="absolute bottom-6 left-6 right-6">
                        <span className="font-display tracking-[0.35em] text-[10px] text-brand-gold">
                            ESCUELA FEMENINA F YOU
                        </span>
                        <div className="font-display text-4xl md:text-5xl text-brand-text mt-2 leading-[0.9]">
                            FUERTE.
                            <br />
                            SEGURA.
                            <br />
                            <span className="orange-text">IMPARABLE.</span>
                        </div>
                    </div>
                </motion.div>

                {/* Content right */}
                <div className="lg:col-span-7 flex flex-col justify-between">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8 }}
                    >
                        <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                            // F YOU WOMEN
                        </span>
                        <h2 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.88] text-brand-text">
                            NO ENTRENES
                            <br />
                            PARA{" "}
                            <span className="text-brand-muted line-through decoration-brand-orange decoration-4">
                                ENCAJAR
                            </span>
                            .
                            <br />
                            ENTRENA PARA
                            <br />
                            <span className="gold-text">DESTACAR.</span>
                        </h2>
                        <p className="mt-7 text-brand-muted text-base md:text-lg max-w-xl leading-relaxed">
                            Diseñamos programas pensados por mujeres y para
                            mujeres. Fuerza real, glúteo, salud hormonal,
                            postparto, recomposición corporal y empoderamiento
                            absoluto. Aquí no se pellizca, aquí se entrena.
                        </p>
                    </motion.div>

                    {/* Pillars grid */}
                    <div className="mt-12 grid grid-cols-2 gap-px bg-white/5">
                        {pillars.map((p, idx) => (
                            <motion.div
                                key={p.n}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: idx * 0.1 }}
                                className="bg-[#0F0F0F] p-6 md:p-7 hover:bg-[#161616] transition-colors group"
                                data-testid={`mujeres-pillar-${idx}`}
                            >
                                <div className="font-display text-xs tracking-[0.3em] text-brand-orange">
                                    {p.n}
                                </div>
                                <div className="font-display text-2xl md:text-3xl mt-2 text-brand-text group-hover:text-brand-orange transition-colors">
                                    {p.t}
                                </div>
                                <div className="text-sm text-brand-muted mt-2">
                                    {p.d}
                                </div>
                            </motion.div>
                        ))}
                    </div>

                    {/* Three small images strip */}
                    <div className="mt-8 grid grid-cols-3 gap-3">
                        {[IMAGES.womanLift1, IMAGES.womanRope, IMAGES.womanGlutes].map(
                            (img, i) => (
                                <div
                                    key={i}
                                    className="relative aspect-[3/4] overflow-hidden border border-white/5"
                                >
                                    <img
                                        src={img}
                                        alt="Mujer fitness"
                                        className="w-full h-full object-cover hover:scale-110 transition-transform duration-700"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 to-transparent" />
                                </div>
                            ),
                        )}
                    </div>

                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="mujeres-cta"
                        className="mt-8 self-start inline-flex items-center gap-3 border-2 border-brand-orange hover:bg-brand-orange hover:text-black text-brand-orange font-display tracking-wider px-7 py-4 transition-all"
                    >
                        ÚNETE A LA ESCUELA FEMENINA
                    </a>
                </div>
            </div>
        </section>
    );
}
